<script>

import axios from 'axios'
import VueApexCharts from 'vue-apexcharts'

export default {
	components: {
        VueApexCharts
    },
  props: {
    title: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "line"
    },
    series: {
      type: Array,
      default: function () {
        return []
      }
    },
    collection: "",
    show_last_modification: {
      type: Boolean,
      default: false
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 0
    },
    range: {
			type: Boolean,
			default: false
    },
  },
  data: function () {
    return {
      name: window.name,
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      refresh: 60000,
      downloadedSeries: [],
      downloadedLabels: [],
      colors: [],
      months: ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      chartOptions: {
        chart: {
          height: 'auto',
        },
        stroke: {
          width: [1, 2, 2, 2, 2]
        },
        // dataLabels: {
        //   enabled: true,
        //   enabledOnSeries: [1]
        // },
        xaxis: {
          type: 'datetime'
        },
        tooltip: {
          x: {
            format: "dd / MM / yyyy"
          }
        },
        colors: [],
        labels: [],
        series: []
      },
    }
  },
  methods: {
    getData: async function (source, type, name, color, labelsSource) {
      let that = this;
      if (that.show_last_modification){
        that.padding_top= '0px';
      }
      if (source === undefined) {
        console.error('Mixed Cortex Incidents Graph Error - Source file not defined in component.');
        return
      }
      let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
      source = source + '&start=0'
      await axios
      .get(baseURL + source)
      .then(function (response) {
          if (response.status === 200) {
            if (response.data.data === undefined || response.data.updated === undefined) {
              console.error('Mixed Cortex Incidents Graph Error - data not defined in source file.')
              return
            }
            let data = []
            let serie = {}

            response.data.data.map(function(entry){
              const label = entry.day.toString()+' '+ that.months[entry.month]+' '+entry.year.toString()
              if (labelsSource !== undefined && labelsSource) {
                that.downloadedLabels.push(label)
                data.push(entry.count)
              } else {
                if(that.downloadedLabels.length > 0 && that.downloadedLabels.includes(label.toString())){
                  data.push(entry.count)
                } else {
                  data.push(0)
                }
              }
            })

            that.colors.push(color)
            that.lastUpdated = new Date(response.data.updated).toLocaleString()
            that.isBusy = false
            serie.name = name
            serie.data = data
            serie.type = type
            that.downloadedSeries.push(serie)
          }
          else if (response.status === 404) {
            console.error('Mixed Cortex Incidents Graph Error - Source file not found.');
            return
          }
      })
			.catch(function (error) {
        console.error('Error loading Mixed Cortex Incidents Graph data. Error:', error.response);
				if (error.response.status === 401 || error.response.status === 403) {
					localStorage.removeItem('idToken')
					that.$router.push({ name: 'Home' })
				}
			})
    },
    async getMoreData(series) {
      const that = this
      await Promise.all(series.map(async (serie) => {
        if (serie.labelsSource === undefined) {
          const color = serie.color || '#d0d0d0'
          await that.getData(serie.source, serie.type, serie.name, color, serie.labelsSource)
        }
      }))
    }
  },
  created: async function() {
    const that = this
    that.chartOptions.labels = that.downloadedLabels
    that.chartOptions.colors = that.colors
    that.chartOptions.series = that.downloadedSeries
    await that.series.map(async (serie) => {
      if (serie.labelsSource) {
        const color = serie.color || '#d0d0d0'
        await that.getData(serie.source, serie.type, serie.name, color, true)
        setTimeout(async function(){
          await that.getMoreData(that.series)
        }, 800)
      }
    })
    // setTimeout(async function(){
    //   await that.getMoreData(that.series)
    // }, 5000)

    // await Promise.all(that.series.map(async (serie) => {
    //   if (serie.labelsSource === undefined) {
    //     const color = serie.color || '#d0d0d0'
    //     await that.getData(serie.source, serie.type, serie.name, color, serie.labelsSource)
    //   }
    // }))
  },
  mounted: async function() {

  }
}
</script>

<template>
  <div>
    <div style="text-align:left !important;">
      <VueApexCharts ref="vchart" :type="type" height="295" :options="chartOptions" :series="downloadedSeries"></VueApexCharts>
    </div>
  </div>
</template>

<style scoped>
  .apexcharts-legend {
      padding-right: 80px;
      line-height: 5px;
      font-size: 8px;
  }
</style>
